<div class="pb-bg-green-70">
  <div class="pb-container-left pb-flex pb-flex-col-reverse lg:pb-flex-row pb-min-h-[564px] xl:pb-max-h-[800px]">
    <div [ngClass]="rendering?.fields?.YellowBox?.value ? 'lg:pb-w-6/12':'pb-pb-7 lg:pb-w-5/12'" class="pb-content-end pb-pt-8 lg:pb-pt-16">
      <p [ngClass]="rendering?.fields?.YellowBox?.value ?'lg:pb-p-6 lg:pb-bg-yellow-60 pb-text-white lg:pb-text-black':'pb-text-white'" class="pb-text-lg-m lg:pb-text-lg" appRichTextRouter *scRichText="rendering?.fields?.Content"></p>
    </div>
    <img class="lg:pb-w-7/12 lg:pb-object-cover lg:pb-object-left-bottom lg:pb-grow" [src]="image.src" [alt]="image.alt"/>
  </div>
</div>
